<app-loader *ngIf="isLoading" [loading]="isLoading" type="fullPage"></app-loader>
<div class="error-wrapper">
    <div *ngIf="isFetchingTokenFailed && !isLoading" class="error-container">
        <div class="error-card">
            <div class="error-icon">⚠</div>
            <h3>{{ 'app.weekly_report_auth_redirect.access_verification_failed' | translate }}</h3>
            <p>{{ 'app.weekly_report_auth_redirect.unable_to_verify_access' | translate }}</p>
        </div>
    </div>

    <div *ngIf="isHandelingAccess && !isLoading" class="error-container">
        <div class="error-card">
            <div class="error-icon">⚠</div>
            <h3>{{ 'app.weekly_report_auth_redirect.access_verification_failed' | translate }}</h3>
            <p>{{ 'app.weekly_report_auth_redirect.something_went_wrong_verifying_access' | translate }}</p>
        </div>
    </div>
</div>